import * as React from 'react';
import { EOrderBy } from 'shared/repositories/valuation-offer-history/entities/offer_history/HouseOfferHistoryRequestV4Schema';

import { IOffer } from '../../../store/offerHistory';

export interface IOfferRowProps {
  selectable?: boolean;
  onClick(): void;
  data: IOffer;
  isActive: boolean;
  isViewed: boolean;
  testId?: string;
  hideButton?: React.ReactNode | null;
}

export interface IOffersFeedProps {
  scrollable?: boolean;
  selectable?: boolean;
  data: IOffer[];
  onOfferClick(offerId: number): void;
  showMoreBtn?: React.ReactElement;
  activeOfferId?: number | null;
  viewedOffers: number[];
  feedViewState: [boolean, (isNarrow: boolean) => void];
  hideButton?: React.ReactNode | null;
}

export interface INearbyHousesInfoData {
  features: TFeatures;
}

export type TFeatures = Array<{ title: string; value: string }>;

export enum EPriceDiff {
  Decrease = 'decrease',
  Increase = 'increase',
  NoChange = 'noChange',
}

export enum EStatus {
  Deactivated = 'deactivated',
  Published = 'published',
}

export type TSortOffersHistoryBy = {
  value: EOrderBy;
  label: string;
};
